import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {apiFetchMe} from '../../../apis/user/getMe'

const useQueryGetMe = (enabled: boolean = true) => {
    return useQuery({
        queryKey: QueryCacheKeys.user.getMe(),
        queryFn: async () => {
            const {data} = await apiFetchMe()
            return data
        },
        refetchOnWindowFocus: false,
        enabled,
    })
}

export default useQueryGetMe
